import { render } from "./DropFiles.vue?vue&type=template&id=4e079b16"
import script from "./DropFiles.vue?vue&type=script&lang=js"
export * from "./DropFiles.vue?vue&type=script&lang=js"

import "./DropFiles.vue?vue&type=style&index=0&id=4e079b16&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__